import type { IFeedback, IFeedbackRaw } from '@/entities/feedback/model/types/feedback';

export const modifyFeedback = (feedback: IFeedbackRaw): IFeedback => ({
  id: feedback?.id,
  creator: feedback?.creator,
  target: feedback?.target,
  targetUserId: feedback?.target_user_id,
  createdAt: feedback?.created_at,
  updatedAt: feedback?.updated_at,
  fullText: feedback?.text?.replaceAll('\n', ' ') ?? '',
  preview: feedback?.title?.replaceAll('\n', ' ') ?? '',
  rate: feedback?.rating ?? 0,
  isLawyer: Boolean(feedback?.creator?.lawyer),
  name: feedback?.creator?.name,
  surname: feedback?.creator?.surname,
  middlename: feedback?.creator?.middlename,
  avatar: feedback?.creator?.avatar,
  isConnected: Boolean(feedback?.is_connected),
  review: feedback?.review,
});
